// MedarbetareArea — the "Medarbetare" area: your team AND invitations in ONE
// view (no tabs). Outstanding (pending) invitations sit in a COMPACT section on
// top — they're few + actionable and stay visible regardless of team size — and
// the full employee roster is the main list below.
import React from 'react';
import { Lightbulb } from 'lucide-react';
import { NEXILINK_SPACING } from '@/lib/nexilink-card-styles';
import { ExplainerCard } from '@/components/custom-ui/ExplainerCard';
import EmployeesPage from './EmployeesPage';
import InvitationsPage from '../invitations/InvitationsPage';

const MedarbetareArea: React.FC = () => {
    return (
        <div className={NEXILINK_SPACING}>
            <ExplainerCard id="employer-employees" icon={Lightbulb} tone="amber" title="Så funkar medarbetare">
                <p className="text-sm text-gray-600 mt-0.5">
                    Bjud in <strong>medarbetare</strong> med e-post, tilldela dem onboarding och följ deras framsteg. Utestående inbjudningar visas överst tills de accepteras.
                </p>
            </ExplainerCard>
            <InvitationsPage />
            <EmployeesPage />
        </div>
    );
};

export default MedarbetareArea;
